import styled from "styled-components";

export const Container = styled.div `

    position: relative;
    margin: -25px -20px 0 -20px;

    .header-bts-back {
        position: absolute;
        left: 0;
        top: 25px;
        display: flex;
        width: 100%;
        padding: 0 20px;
        justify-content: space-between;
        z-index: 9;
    }

    .header-bts-back a {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #30303099;
        border: 2px solid #aaa;
        border-radius: 50%;
        padding: 10px;
        transition: all .3s ease;
    }

    .header-bts-back a:hover {
        border-color: #fff;
        background: #000;
    }

    .content-movie-assistir {
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: top;
    }

    .movie-assistir {
        position: relative;
    }

    .div-padding-detalhes-movie-mobile {
        min-width: 100%;
        padding: 20px 2rem 2rem 2rem;
        background-image: linear-gradient(to top, #252525, #252525 1%, #25252500);
    }

    .movie-assistir::-webkit-scrollbar {
        display: none;
    }

    .div-img-background-mobile {
        display: flex;
        align-items: center;
        position: relative;
        min-width: 100%;
        max-width: 100%;
        height: 60vh;
        max-height: 600px;
        overflow: hidden;
        margin-bottom: -20px;
    }

    .div-img-background-mobile:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(to top, #252525, #252525 1%, #25252500);
    }

    .div-img-background-mobile img {
        min-width: 100%;
        max-width: 100%;
        min-height: ${props => props.background ? '60vh' : '30vh'};
        max-height: ${props => props.background ? '60vh' : '30vh'};
        object-fit: ${props => props.background ? 'cover' : 'contain'};
    }

    .header-details-movie {
        position: absolute;
        left: 10px;
        bottom: 0;
        padding: 0 20px 0 20px;
        z-index: 1;
    }

    .div-padding-detalhes-movie-mobile {
        position: relative;
        max-width: 100%;
    }

    .detalhes-movie-assistir {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        max-width: 100%;
        z-index: 2;
    }

    .detalhes-movie-assistir .span-assistir-filmes-series {
        font-size: .7rem;
        text-transform: uppercase;
        color: #ccc;
        letter-spacing: .5px;
        font-weight: 600;
        margin-right: 10px;
    }

    .detalhes-movie-assistir .div-title {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        justify-content: space-between;
        width: 100% !important;
    }

    .detalhes-movie-assistir .titulo-movie-assistir {
        font-size: 3rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        margin-top: -10px;
        -webkit-box-orient: vertical;
    }

    .h5-titulo-movie {
        margin-bottom: 5px;
        font-weight: 600;
    }

    .detalhes-movie-assistir .informacoes-movie-assistir {
        display: flex;
        margin-bottom: .5rem;
        overflow-x: auto;
        max-width: 100%;
    }

    .detalhes-movie-assistir .informacoes-movie-assistir section {
        padding: .5rem .2rem .5rem 0;
        border-radius: 3rem;
        font-weight: 600;
        font-size: .8rem;
        text-transform: uppercase;
        cursor: default;
        transition: all .3s ease;
    }

    .detalhes-movie-assistir .informacoes-movie-assistir section:hover {
        opacity: .7;
    }

    .detalhes-movie-assistir .informacoes-movie-assistir section:last-child {
        margin-right: 0;
    }

    .detalhes-movie-assistir .informacoes-movie-assistir .section-temporadas {
        display: flex;
    }

    .detalhes-movie-assistir .informacoes-movie-assistir section span {
        white-space: nowrap;
    }

    .detalhes-movie-assistir .descricao-movie-assistir {
        font-size: .85rem;
        font-weight: 600;
        color: #ccc;
        margin-bottom: .5rem;
    }

    .detalhes-movie-assistir .generos-movie-assistir {
        max-width: 100%;
        overflow-x: auto;
    }

    .detalhes-movie-assistir .generos-movie-assistir a {
        font-size: .7rem;
        background: #20202030;
        color: #fff;
        font-weight: 600;
        margin: 3px 1px;
        cursor: pointer;
        border-radius: 50px;
        text-decoration: underline;
        white-space: nowrap; 
        transition: all .2s ease;
    }

    .detalhes-movie-assistir .generos-movie-assistir a:last-child {
        margin-right: 0;
    }

    .detalhes-movie-assistir .generos-movie-assistir a:hover {
        color: #ccc;
    }

    @media (max-width: 1000px) {

        .detalhes-movie-assistir {
            max-width: 100%;
        }
    }

    @media (max-width: 800px) {
        
        .detalhes-movie-assistir {
            max-width: 100%;
            margin-left: 0;
        }

        .header-details-movie {
            padding: 0 .4rem 0 1rem;
        }

        .div-padding-detalhes-movie-mobile {
            padding: 0 1rem 1rem 1.4rem;
        }

        .div-img-background-mobile {
            margin-bottom: 0;
        }

        .detalhes-movie-assistir .titulo-movie-assistir {
            font-size: 2rem;
            width: 100%;
        }

        .detalhes-movie-assistir .descricao-movie-assistir {
            font-size: .8rem;
        }
    }

    @media (max-width: 600px) {

        .movie-assistir {
            padding: 0 0 1rem 0;
        }

        .div-img-background-mobile {
            position: relative;
            min-width: 100%;
            max-width: 100%;
            min-height: 40vh;
            max-height: 40vh;
            overflow: hidden;
            background: #222222;
        }
        
        .div-img-background-mobile img {
            min-width: 100%;
            max-width: 100%;
            min-height: ${props => props.background ? '40vh' : '20vh'};
            max-height: ${props => props.background ? '40vh' : '20vh'};
        }

        .header-details-movie {
            padding: 0 .3rem;
        }

        .div-padding-detalhes-movie-mobile {
            padding: 0 1rem 1rem 1rem;
        }

        .detalhes-movie-assistir .titulo-movie-assistir {
            font-size: 150%;
            width: 100%;
            -webkit-line-clamp: 2;
            margin-top: -5px;
        }

        .detalhes-movie-assistir .descricao-movie-assistir {
            font-size: .7rem;
            margin-bottom: .3rem;
        }

        .detalhes-movie-assistir .generos-movie-assistir::-webkit-scrollbar, .detalhes-movie-assistir .informacoes-movie-assistir::-webkit-scrollbar {
            display: none;
        }

        .detalhes-movie-assistir .generos-movie-assistir span {
            font-size: .6rem;
            margin-right: .5rem;
        }
    }

`
